const errorPrefix = 'B2BACCOUNT_ERR_CD_';

const suffixMandatory = '_MANDATORY';

export const formErrorMessages = {
  agreementPricingCodeInvalid: {
    code: `${errorPrefix}${suffixMandatory}`,
    message: `We're sorry. There has been a temporary technical error. Please try again shortly.`,
  },

  // EIN - Start
  einInvalid: {
    code: `${errorPrefix}${suffixMandatory}`,
    message: `Please provide Valid Tax Payer ID / EIN.`,
  },

  einRequired: {
    code: `${errorPrefix}${suffixMandatory}`,
    message: `Please provide your Tax Payer ID / EIN. We require Tax Payer ID / EIN when using an Agreement Code.`,
  },

  eINPricingInvalid: {
    code: `${errorPrefix}${suffixMandatory}`,
    message: `Please enter your 9 digit EIN.`,
  },

  eINPricingRequired: {
    code: `${errorPrefix}${suffixMandatory}`,
    message: `Please enter your 9 digit EIN.`,
  },

  // EIN - End
};
